"use client"
import Link from "next/link"
import { Camera, Heart, Users, Image as LucideImage, Sparkles, Eye, Calendar, Instagram, Menu, ChevronDown, Phone, Mail, MapPin } from "lucide-react"

const ICON_MAP = {
  Camera,
  Heart,
  Users,
  Image: LucideImage,
  Sparkles,
  Eye,
  Calendar,
  Instagram,
  Menu,
  ChevronDown,
  Phone,
  Mail,
  MapPin,
}

function getLucideIcon(iconName: string): React.ComponentType<{ className?: string }> {
  return ICON_MAP[iconName as keyof typeof ICON_MAP] || LucideImage
}

export default function GalleryNavItems({ galleries, mobile = false }: { galleries: any[]; mobile?: boolean }) {
  if (mobile) {
    return (
      <>
        {galleries.map((item) => (
          <Link
            key={item.fields.slug}
            href={`/galleries/${item.fields.slug}`}
            scroll={true}
            className="block transition-colors text-gray-600 hover:text-purple-600"
          >
            {item.fields.galleryName}
          </Link>
        ))}
      </>
    )
  }
  return (
    <>
      {galleries.map((item) => {
        const Icon = getLucideIcon(item.fields.icon)
        console.log("Dropdown icon value:", item.fields.icon, Icon)
        return (
          <Link
            key={item.fields.slug}
            href={`/galleries/${item.fields.slug}`}
            scroll={true}
            className="flex items-start space-x-3 p-3 rounded-md hover:bg-gray-50 transition-colors"
          >
            <Icon className="h-5 w-5 text-purple-600 mt-0.5" />
            <div>
              <div className="font-medium text-gray-900">{item.fields.galleryName}</div>
              {item.fields.subHeading && <div className="text-sm text-gray-600">{item.fields.subHeading}</div>}
            </div>
          </Link>
        )
      })}
    </>
  )
} 